import { DefaultHandlerProvider, Environment } from 'relay-runtime';

import { createNetwork } from './network';
import { createStore } from './store';

import { DEFAULT_CACHE_OPTIONS } from '../constants';
import type { initEnvironmentArgs } from '../types';

function initEnvironment({
  handlerProvider = DefaultHandlerProvider,
  network: { middlewares, options },
  store,
  environmentOptions,
}: initEnvironmentArgs) {
  let cacheOptions = options?.cacheOptions || DEFAULT_CACHE_OPTIONS;

  store = store || createStore();

  return new Environment({
    ...(environmentOptions && { ...environmentOptions }),
    handlerProvider,
    network: createNetwork(middlewares, {
      minification: process.env.QUERY_MINIFICATION === 'true',
      ...options,
      cacheOptions,
    }),
    store,
  });
}

export { initEnvironment };
